import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/Layout";
import { useTranslation } from "react-i18next";
import Table from "react-bootstrap/Table";
import axios from "axios";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
} from "react-bootstrap";
import { VscFilePdf } from "react-icons/vsc";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// React Icons
import { AiOutlineClose } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const SupplierLedgers = () => {
  const mainLogoNew = `/assets/fakt-logo.png`;

  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const [deductionList, setDeductionList] = useState({
    data: [],
    pageNumber: 1,
    selectedPdfData: {},
    clickedOnViewDetails: false,
  });

  const [promiseState, setPromiseState] = useState({
    pending: false,
    fulfilled: false,
    rejected: false,
  });

  const [deduction, setDeduction] = useState({
    totalResults: [],
    formattedData: [],
  });

  useEffect(() => {
    const getDeduction = async () => {
      try {
        setPromiseState({ pending: true });
        const res = await axios.get("/Salary/deduction");
        const removeDuplicateObjects = (array, property) => {
          const uniqueIds = [];
          const unique = array.filter((element) => {
            const isDuplicate = uniqueIds.includes(element[property]);
            if (!isDuplicate) {
              uniqueIds.push(element[property]);
              return true;
            }
            return false;
          });
          return unique;
        };

        const formattedData = removeDuplicateObjects(
          res.data.response,
          "invoiceNumber"
        ).map((item) => ({
          invoiceNumber: item.invoiceNumber,
          createdDate: item.invoice.createdDate.split("T")[0],
          customerName: item.customerName,
        }));
        setPromiseState({ fulfilled: true });
        setDeduction({
          formattedData,
          totalResults: res.data.response,
        });
      } catch (error) {
        setPromiseState({ rejected: true });
      }
    };
    getDeduction();
  }, []);

  useEffect(() => {
    const slicedArray = deduction?.formattedData.slice(
      Number(deductionList.pageNumber + "0") - 10,
      Number(deductionList.pageNumber + "0") || deductionList.length - 1
    );
    setDeductionList((prevState) => ({ ...prevState, data: slicedArray }));
  }, [deductionList, deduction.formattedData]);

  const onClickPdfIcon = (
    selectedInvoiceNumber,
    customerName,
    clickedOnViewDetails
  ) => {
    let vat = 0;
    let tax = 0;
    let totalAmount = 0;
    let createdDate = "";
    let workingDate = [];
    let formattedRow = {};
    let deductionAmount = 0;
    const selectedRow = deduction.totalResults.filter(
      (item) => item.invoiceNumber === selectedInvoiceNumber
    );
    const invoiceData= deductionList.data.find((item) => item.invoiceNumber === selectedInvoiceNumber);

    selectedRow.forEach((item) => {
      tax = item.invoice.tax;
      vat = item.invoice.vat;
      totalAmount += item.invoice.amount;
      deductionAmount += item.amountPerUnit;
      createdDate = item.invoice.createdDate.split("T")[0];
      workingDate = [...workingDate, item.workingDate.split("T")[0]];
    });

    formattedRow = {
      vat,
      tax,
      totalAmount,
      createdDate,
      workingDate,
      unit: "förp",
      customerName,
      amountPerUnit: deductionAmount,
      invoiceNumber: invoiceData.invoiceNumber
    };
    setDeductionList((prevState) => ({
      ...prevState,
      selectedPdfData: formattedRow,
      clickedOnViewDetails: clickedOnViewDetails ? true : false,
    }));
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById("deduction-modal");
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgWidth = 210;
        const pageHeight = 290;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jsPDF("p", "mm"); // eslint-disable-line new-cap
        let position = 0;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save("deductions-details.pdf");
      });
    }
    setDeductionList((prevState) => ({
      ...prevState,
      selectedPdfData: {},
      clickedOnViewDetails: false,
    }));
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 create_invoices invoice-space supplier-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/supplier-ledgers"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/leverantorsreskontra"
          />
        )}
      </Helmet>
      <div className="page-content supplierLeger">
        <div className="deductions">
          <div className="deduction_txt_wrap">
            <h4 className="accident_ins font-weight-bold">
              {t("Your deductions")}
            </h4>
            <p>
              <span>{t("suphere")}</span>
            </p>
          </div>

          <div className="table-div">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="invoice_tabeletext">{t("Serial No.")}</th>
                  <th className="invoice_tabeletext">{t("Invoice No")}</th>
                  <th className="invoice_tabeletext">{t("Customer Name")}</th>
                  <th className="invoice_tabeletext">{t("Created Date")}</th>
                  <th className="text-center invoice_tabeletext">
                    {t("Action")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {deductionList.data?.map((data, index) => {
                  return (
                    <tr key={data.invoiceNumber}>
                      <td>{index + 1}</td>
                      <td>{data.invoiceNumber}</td>
                      <td>{data.customerName}</td>
                      <td>{data.createdDate}</td>

                      <td className="d-flex justify-content-center align-items-center">
                        <div className="hover-text">
                          <button
                            data-toggle="tooltip"
                            data-placement="top"
                            title={t("View")}
                            className="salary_view"
                            onClick={() =>
                              onClickPdfIcon(
                                data.invoiceNumber,
                                data.customerName,
                                "clickedOnViewDetails"
                              )
                            }
                          >
                            <FaEye size={14} />
                          </button>
                        </div>
                        <div className="pdfIcon">
                          <VscFilePdf
                            className="ml-2"
                            title={t("Download PDF")}
                            onClick={() =>
                              onClickPdfIcon(data.invoiceNumber, data.customerName)
                            }
                            size={35}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {promiseState.pending ? (
              <div className="text-center">
                <div
                  className="spinner-border text-primary spinner-border-lg"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : deduction.formattedData.length === 0 &&
              promiseState.fulfilled ? (
              <div className="text-center">
                <h2>{t("No data found")}</h2>
              </div>
            ) : promiseState.rejected ? (
              <div className="text-center">
                <h2>
                  {t("Found an error please try again within few minutes")}
                </h2>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <Pagination className="paginationInvoice">
        {deduction.formattedData.length > 10 &&
          new Array(Math.ceil(deduction.formattedData.length / 10))
            .fill(undefined)
            .map((_, key) => (
              <Pagination.Item
                activeLabel=""
                active={deductionList.pageNumber - 1 === key}
                key={key}
                onClick={() => {
                  setDeductionList((prevState) => ({
                    ...prevState,
                    pageNumber: key + 1,
                  }));
                }}
              >
                {key + 1}
              </Pagination.Item>
            ))}
      </Pagination>

      {deductionList.selectedPdfData.hasOwnProperty("invoiceNumber") && (
        <Modal
          show={true}
          onHide={() =>
            setDeductionList((prevState) => ({
              ...prevState,
              selectedPdfData: {},
              clickedOnViewDetails: false,
            }))
          }
        >
          <ModalHeader>
            {deductionList.clickedOnViewDetails
              ? t("Deduction Details")
              : t("Download PDF")}
            .
            <AiOutlineClose
              size={25}
              onClick={() =>
                setDeductionList((prevState) => ({
                  ...prevState,
                  selectedPdfData: {},
                  clickedOnViewDetails: false,
                }))
              }
            />
          </ModalHeader>
          <ModalBody id="deduction-modal">
            <div className="page-content EconomyInvoices">
              <div className="invoice-details-part-container flex-column mt-4 w-100">
                {!deductionList.clickedOnViewDetails && (
                  <span className="invoice-details-title">
                    <img
                      className={`mr-4 mb-4 logo img-fluid`}
                      src={mainLogoNew}
                      alt="site-logo"
                      loading="lazy"
                    />
                  </span>
                )}
                <span className="invoice-details-title">
                  {t("Your deductions")}
                </span>
              </div>
              <div>
                <div className="deductionDetails">
                  <p className="m-0">{t("Invoice No")}</p>
                  <p className="m-0 ml-auto">
                    # {deductionList.selectedPdfData?.invoiceNumber}
                  </p>
                </div>
                <div className="deductionDetails">
                  <p className="m-0">{t("Customer Name")}</p>
                  <p className="m-0 ml-auto">
                    {deductionList.selectedPdfData?.customerName}
                  </p>
                </div>
                <div className="deductionDetails">
                  <p className="m-0">{t("Total Amount")}</p>
                  <p className="m-0 ml-auto">
                    SEK{" "}
                    {deductionList.selectedPdfData?.totalAmount?.toLocaleString(
                      LOCALES.EN_US 
                    )}
                  </p>
                </div>
                <div className="deductionDetails bg-highlight">
                  <p className="m-0">{t("Deduction Amount")}</p>
                  <p className="m-0 ml-auto">
                    SEK{" "}
                    {deductionList.selectedPdfData?.amountPerUnit?.toLocaleString(
                      LOCALES.EN_US
                    )}
                  </p>
                </div>
                <div className="deductionDetails">
                  <p className="m-0">{t("VAT")}</p>
                  <p className="m-0 ml-auto">
                    {deductionList.selectedPdfData?.vat}%
                  </p>
                </div>
                <div className="deductionDetails">
                  <p className="m-0">{t("Article Unit")}</p>
                  <p className="m-0 ml-auto">
                    {t(deductionList.selectedPdfData?.unit)}
                  </p>
                </div>
                <div className="deductionDetails">
                  <p className="m-0">{t("Created Date")}</p>
                  <p className="m-0 ml-auto">
                    {deductionList.selectedPdfData?.createdDate}
                  </p>
                </div>
                <div className="invoice-details-part-container flex-column w-100 mt-3">
                  <span className="invoice-details-title">
                    {t("WORKING DATE")}
                  </span>
                  <div className="invoice-details-border-container">
                    <div className="invoice-details-dates">
                      {deductionList.selectedPdfData?.workingDate?.map(
                        (date, index) => {
                          return (
                            <div
                              key={index}
                              className="invoice-details-date-container"
                            >
                              <div className="invoice-details-date">
                                <span>{date}</span>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="deduction">
            <button
              className="outline_btn_new close-deduction"
              onClick={() =>
                setDeductionList((prevState) => ({
                  ...prevState,
                  selectedPdfData: {},
                  clickedOnViewDetails: false,
                }))
              }
            >
              {deductionList.clickedOnViewDetails ? t("Close") : t("Cancel")}
            </button>
            {!deductionList.clickedOnViewDetails && (
              <Button
                className="dowloand-deduction"
                onClick={() => handleDownloadPDF()}
              >
                {t("Download")}
              </Button>
            )}
          </ModalFooter>
        </Modal>
      )}
    </Layout>
  );
};

export default SupplierLedgers;
